// extracted by mini-css-extract-plugin
export default {"IconButton":"styles_IconButton__8Cyj3"};